import React from 'react';
import './App.css';
import NavBar from './NavBar';
import ServiceCard from './ServiceCard';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      {/* Header */}
      <NavBar />

      <section id="inicio" className="hero">
        <img src="/assets/fondoinicio.png" alt="Branch" className="branch-asset" />
        <div className="hero-content">
          <h2 className="hero-title">Donde la Innovación Echa Raices</h2>
          <p className="hero-subtitle">
           Desarrollo de software a medida y soluciones técnicas para expandir tu negocio
          </p>
        </div>
      </section>

      {/* Sección Cómo Trabajamos */}
      <section className="como-trabajamos">
        <div className="services-container">
          <ServiceCard
            services={[
              {
                title: 'Software',
                description: 'Desarrollamos aplicaciones a medida, integraciones y sistemas internos que automatizan y potencian tu negocio desde cero.',
                route: '/software',
                image: '/assets/fondosoftware.png',
              },
              {
                title: 'Web Design',
                description: 'Diseñamos sitios modernos, responsivos y orientados a la experiencia del usuario, desde landing pages hasta e-commerce completos.',
                route: '/web-desing',
                image: '/assets/fondost.png',
              },
              {
                title: 'Servicio Técnico',
                description: 'Brindamos soporte especializado, diagnóstico, mantenimiento y optimización continua para mantener tu infraestructura en óptimas condiciones.',
                route: '/servicio-tecnico',
                image: '/assets/fondosofwaremed1.png',
              },
            ]}
          />
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default App;
